import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const ClientRegistrationDocuments = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const languages = [
    { name: "Urdu", file: "urdu.zip" },
    { name: "Telegu", file: "telegu.zip" },
    { name: "Tamil", file: "tamil.zip" },
    { name: "Sindhi", file: "sindhi.zip" },
    { name: "Punjabi", file: "punjabi.zip" },
    { name: "Oriya", file: "oriya.zip" },
    { name: "Marathi", file: "marathi.zip" },
    { name: "Malyalam", file: "malyalam.zip" },
    { name: "Konkani", file: "konkani.zip" },
    { name: "Kashmiri", file: "kashmiri.zip" },
    { name: "Kanada", file: "kanada.zip" },
    { name: "Hindi", file: "hindi.zip" },
    { name: "Gujrati", file: "gujrati.zip" },
    { name: "Bengali", file: "bengali.zip" },
    { name: "Assamese", file: "assamese.zip" },
  ];

  return (
    <div className="page-content">
      <SEO
        title="Client Registration Documents in Vernacular Languages"
        description="Download client registration documents and KYC forms in various Indian vernacular languages including Hindi, Bengali, Marathi, Gujarati, and more."
      />

      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Client Registration Documents in Vernacular</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mb-4">
              <h2>Client Registration Docs In Vernacular Language</h2>
            </div>
          </div>
          <div className="row">
            {languages.map((lang, index) => (
              <div className="col-lg-4 mb-4" key={index}>
                <div className="download-box">
                  <div className="media">
                    <img
                      src="/images/pdf-icon.png"
                      className="mr-3"
                      alt="PDF icon"
                    />
                    <div className="media-body align-self-center">
                      <h5 className="mt-0 mb-2">{lang.name}</h5>
                      <a
                        href={`/pdf/${lang.file}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-download" aria-hidden="true"></i>{" "}
                        Download
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a
                href="#download"
                className="lm-btn"
                onClick={(e) => e.preventDefault()}
              >
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="/images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default ClientRegistrationDocuments;
